import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { AvatarItem } from './avatar-item';
const AvatarList = (param)=>{
    let { limitedRightDataItemHref, list, showAmount = 3, showElse } = param;
    if (!list.length) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-end",
        "data-e2e": "avatar-list",
        children: [
            list.slice(0, showAmount).map((item, index)=>{
                const zIndex = list.length - index;
                const marginLeft = index === 0 ? '0px' : '-8px';
                const style = {
                    marginLeft,
                    zIndex
                };
                return /*#__PURE__*/ _jsx(AvatarItem, {
                    avatar: item,
                    style: style
                }, "avatar-item-".concat(index.toString()));
            }),
            showElse && list.length > showAmount && /*#__PURE__*/ _jsxs(Link, {
                to: limitedRightDataItemHref !== null && limitedRightDataItemHref !== void 0 ? limitedRightDataItemHref : '/',
                className: "inline-flex items-center justify-items-center text-center text-[13px] font-light leading-[150%] text-muted-foreground",
                children: [
                    "\xa0 + ",
                    list.length - showAmount
                ]
            })
        ]
    });
};
export { AvatarList };
